export default __webpack_public_path__ + "static/media/fingers-crossed.dc8aafa1.svg";